export const driverNameMapping: any = {
  'Completion Rate - Product': 'Completion Rate - Product (%)',
  'Completion Rate - Sales': 'Completion Rate - Sales (%)',
  'Contacts per Account': 'Contacts per Account (#)',
  'Multi Thread Score': 'Multi Thread Score (#)',
  'Time w/ Customers': 'Time w/ Customers (Hrs/Qtr)',
  'Time w/ Partners': 'Time w/ Partners (Hrs/Qtr)',
  'Manager Rep 1:1 Frequency': 'Manager Rep 1:1 Frequency (Hrs/Qtr)',
  'Accounts Touched':'Accounts Touched (%)'
};
export const keyDriverData1 = [
  {
    name: 'Time With Customers',
    value: 11.5,
    global_max_value: 49.68,
    global_mean_value: 33.72,
  },
  {
    name: 'Follow Up Ratio',
    value: 5.8,
    global_max_value: 20.5,
    global_mean_value: 12.71,
  },
  {
    name: 'Technical Skills',
    value: 1.5,
    global_max_value: 5,
    global_mean_value: 3.45,
  },
];
export const keyDriverData2 = [
  {
    name: 'Pipeline Discipline',
    value: 32.5,
    global_max_value: 42,
    global_mean_value: 29.51,
  },
  {
    name: 'Time With Product Team',
    value: 25.65,
    global_max_value: 30.75,
    global_mean_value: 13.26,
  },
  {
    name: 'Technical Skills',
    value: 4.3,
    global_max_value: 5,
    global_mean_value: 3.45,
  },
];
export const keyDriverData3 = [
  {
    name: 'MEDPICC Score',
    value: 29.5,
    global_max_value: 99,
    global_mean_value: 60.61,
  },
  {
    name: 'Time With Product Team',
    value: 7.2,
    global_max_value: 30.75,
    global_mean_value: 13.26,
  },
  {
    name: 'Communication skills',
    value: 1.2,
    global_max_value: 5,
    global_mean_value: 3.45,
  },
];
export const keyDriverData4 = [
  {
    name: 'Pipeline Discipline',
    value: 32.5,
    global_max_value: 42,
    global_mean_value: 29.51,
  },
  {
    name: 'Time With Customers',
    value: 38.65,
    global_max_value: 49.68,
    global_mean_value: 33.69,
  },
  {
    name: 'Communication skills',
    value: 4.4,
    global_max_value: 5,
    global_mean_value: 3.45,
  },
];
export const keyDriverData5 = [
  {
    name: 'Time With Customers',
    value: 11.5,
    global_max_value: 49.68,
    global_mean_value: 33.72,
  },
  {
    name: 'Pipeline Discipline',
    value: 12.5,
    global_max_value: 42,
    global_mean_value: 29.51,
  },
  {
    name: 'Technical Skills',
    value: 1.5,
    global_max_value: 5,
    global_mean_value: 3.45,
  },
];
export const keyDriverData6 = [
  {
    name: 'MEDPICC Score',
    global_min_value: 0,
    global_max_value: 99,
    global_mean_value: 71.5,
  },
  {
    name: 'Time With Customers',
    global_mean_value: 41.5,
    global_max_value: 49.6,
    global_min_value: 0,
  },
  {
    name: 'Technical Skills',
    global_mean_value: 4.1,
    global_max_value: 5,
    global_min_value: 0,
  },
];
export const keyDriverData7 = [
  {
    name: 'Time With Customers',
    value: 41.5,
    global_max_value: 49.68,
    global_mean_value: 33.72,
  },
  {
    name: 'Communication skills',
    value: 4.4,
    global_max_value: 5,
    global_mean_value: 3.45,
  },
  {
    name: 'MEDPICC Score',
    value: 71.5,
    global_max_value: 99,
    global_mean_value: 60.61,
  },
];
export const keyDriverData8 = [
  {
    name: 'Technical Skills',
    value: 4.2,
    global_max_value: 5,
    global_mean_value: 3.45,
  },
  {
    name: 'MEDPICC Score',
    value: 71.5,
    global_max_value: 99,
    global_mean_value: 60.61,
  },
  {
    name: 'Time With Customers',
    value: 41.5,
    global_max_value: 49.68,
    global_mean_value: 33.72,
  },
];

export const keyDriverData9 = [
  {
    name: 'Follow Up Ratio',
    global_min_value: 0,
    global_max_value: 20.4,
    global_mean_value: 12.7,
  },
  {
    name: 'MEDPICC Score',
    global_min_value: 0,
    global_max_value: 99,
    global_mean_value: 64.2,
  },
  {
    name: 'Technical Skills',
    global_min_value: 0,
    global_max_value: 5,
    global_mean_value: 3.4,
  },
];

export const ignoredReps = [
  '3e6bfd8e-8f0b-481c-95e9-866f79c22508',
];
